export default __webpack_public_path__ + "static/media/the-oh-hellos.1530bc82.jpg";